<template>
	<div class="mgray" :style="{'--menu-width':menuWidth+'px','--menu-width-negative':'-'+menuWidth+'px'}">
		<div class="main">
			<div class="peripheral clearfix">
				<div class="nav">
					<h3><img style="width: 20px;" src="@/assets/title.png">{{title}}</h3>
					<div class="text">
						<router-link :to="item.path" :class="{'active': item.path === active }" v-for="item in menu" :key="item.id" @click.native="active = item.path">{{item.title}}</router-link>
					</div>
				</div>

				<div class="industry">
					<div class="box">
						<div class="mbx">
							当前位置：
							<router-link to="/home">首页</router-link>
							<a>{{menu.find(item => item.path === active).title}}</a>
						</div>
					</div>
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			menu: {
				type: Array,
				default () {
					return []
				}
			},
			title: {
				type: String
			},
			menuWidth: {
				type: Number,
				default () {
					return 300
				}
			}
		},
		data() {
			return {
				active: 'company'
			}
		},
		watch: {
			$route(val) {
				this.active = val.path.substring(val.path.lastIndexOf('/') + 1)
			}
		},
		created() {
			let path = this.$route.path
			this.active = path.substring(path.lastIndexOf('/') + 1)
		}
	}
</script>


<style scoped >
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	hr,
	dt,
	dd,
	dl {
		font-size: 14px;
		margin: 0;
		padding: 0;
		font-weight: normal;
	}

	.banxx {
		height: 210px;
	}
	
	.banxx .main {
		height: 100%;
		max-width: 1220px !important;
		margin: 0 auto !important;
		padding: 0px 10px;
	}
	
	.banxx .text {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.banxx .text h3 {
		font-size: 34px;
		color: #fff;
		font-weight: normal;
		margin: 0;
	}
		
	.banxx .text p {
		color: #fff;
		font-size: 16px;
		margin-top: 10px;
	}

	.mgray {
		background: #f3f3f2;
		padding: 70px 0px;
		font-size: 14px;
	}
	
	.mgray .main {
		min-height: 400px;
		max-width: 1220px !important;
		margin: 0 auto !important;
		padding: 0px 10px;
	}
	
	.mgray .main .peripheral {
		padding-left: var(--menu-width);
	}
	
	.mgray .main .peripheral .nav {
		margin-left: var(--menu-width-negative);
		float: left;
		width: var(--menu-width);
		background: #fff;
	}
	
	.mgray .main .peripheral .nav h3 {
		padding: 30px 40px;
		font-size: 24px;
		color: #151515;
	}
	
	.mgray .main .peripheral .nav h3 img {
		display: inline-block;
		vertical-align: middle;
		margin-right: 10px;
		margin-top: -2px;
	}
		
	.mgray .main .peripheral .nav .text a.active {
		background: #151515;
		color: #fff;
	}
	
	.mgray .main .peripheral .nav .text a.active:after {
		content: '';
		display: block;
		width: 6px;
		height: 6px;
		border: 2px solid rgba(255, 255, 255, 1);
		border-top: 0px;
		border-left: 0px;
		right: 30px;
		top: 50%;
		transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
		position: absolute;
		margin-top: -3px;
	}
	
	.mgray .main .peripheral .nav .text a {
		padding: 13px 40px;
		display: block;
		font-size: 16px;
		color: #333;
		transition: all 0.6s;
		-webkit-transition: all 0.6s;
		-moz-transition: all 0.6s;
		position: relative;
		text-decoration: none;
	}
	
	.mgray .main .peripheral .nav .text a:hover {
		color: #fff;
		background-color: #333;
	}
	
	.mgray .main .peripheral .industry {
		padding-left: 20px;
	}
	
	.mgray .main .peripheral .industry .box {
		background: #fff;
	}
	
	.mgray .main .peripheral .industry .box .mbx {
		border-bottom: 2px solid #e7e7e6;
		padding: 25px;
		font-size: 14px;
	}
	
	.mgray .main .peripheral .industry .box .mbx a {
		background: url(http://www.gdi.com.cn/themes/basic/skin/images/z1.png) no-repeat right center;
		text-decoration: none;
		padding-right: 15px;
		margin-right: 10px;
		color: #666666;
	}
		
	.mgray .main .peripheral .industry .box .mbx a:last-child {
		background: initial;
	}
		
	.mgray .main .peripheral .industry .box .mbx a:hover {
		color: orangered;
	}
		
	.mgray .main .peripheral .industry .box .mbx a:last-child:hover {
		color: initial;
	}
		
	.mgray .main .clearfix {
		display: block;
		clear: both;
	}
</style>
